import React from 'react';
import DOMPurify from 'dompurify';
import { Button, Card, Image } from 'react-bootstrap';

interface IAlertBox {
    classCol: string;
    variant?: string;
    textButton?: string;
    functionBtn?: (...args: any) => void;
    image?: string;
    title: string;
    desc: string;
    classBody?: string;
    isDisabled?: boolean;
}

export default function AlertBox({
    classCol = 'col',
    image,
    variant = 'primary',
    title,
    desc,
    textButton,
    functionBtn,
    classBody,
    isDisabled = false,
}: IAlertBox) {
    return (
        <div className={classCol ?? ''}>
            <Card className={`border border-${variant} card-body d-flex align-items-md-center flex-column flex-md-row`}>
                <div className={`d-flex align-items-center ${classBody}`}>
                    {!!image && <Image className="mr-3" src={image} alt="alert-image" height={40} />}
                    <div>
                        <h5 className="mb-0">{title}</h5>
                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(desc) }} className="text-muted" />
                    </div>
                </div>
                {!!textButton && (
                    <div className="d-flex justify-content-end align-items-center col pr-1">
                        <Button
                            variant={`outline-${variant}
                             w-maxContent mt-1 mt-md-0 text-capitalize`}
                            onClick={functionBtn}
                            disabled={isDisabled}
                            aria-disabled={isDisabled}
                        >
                            {textButton}
                        </Button>
                    </div>
                )}
            </Card>
        </div>
    );
}
